import BaseView from "./_BaseView";
import LineGraph from "../graphs/LineGraph";
import Table from "../components/Table";

export default class RoleAnalyticsView extends BaseView {

    init() {
        super.init();

        if ($('#roleAnalyticsView').length > 0) {
            LineGraph({
                container: '#roleAnalyticsView',
                svg: '.roleanalytics',
                counter: Lang.pageviews.toLocaleLowerCase(),
                curved: true,
                filled: true,
                yLabel: Lang.pageviews
            });
        }

        if ($('#roleAnalyticsViewTable').length > 0) {
            const url = `/api/analytics/roleanalytics?daterange=${$('[name="daterange"]').val()}&path=${$('input[name="page"]').val()}`;
            this.table = new Table('roleAnalyticsViewTable', url, [
                {data: 'user', orderable: true},
                {data: 'date'},
                {data: 'count', orderable: true},
            ]);
        }
    }

    setEvents() {
        super.setEvents();
        const self = this;
        if ($('#roleAnalyticsView').length > 0) {
            $('[name="daterange"]').on('change', function () {
                $('.period').text($('select[name="daterange"] option:selected').text());
                self.table.table.ajax.url(
                    '/api/analytics/roleanalytics'
                    + `?daterange=${$('[name="daterange"]').val()}`
                    + `&path=${$('input[name="page"]').val()}&app=${$('[data-app]').data('app')}`);
                self.table.reload();
            });
        }
    }
}
